<template>
    <div class="course-order-management">

        <el-dialog
            :visible.sync="dialog.visible"
            @close="handleCancel()"
            width="30%">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                课程订单导出
            </div>

            <el-form :model="dialog.content" ref="formContent" label-width="112px">
                <el-form-item label="导出门店: ">
                    <el-select clearable v-model="dialog.content.storeId" placeholder="请选择导出门店" :disabled="this.$store.getters.getUserInfo.storeId != undefined">
                        <el-option v-for="item in storeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="起始时间: ">
                    <el-date-picker
                        v-model="dialog.content.begin"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime"
                        placeholder="请选择起始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间: ">
                    <el-date-picker
                        v-model="dialog.content.end"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime"
                        placeholder="请选择结束时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="cancel"  size="small" @click="handleCancel()">取消</el-button>
                <el-button type="primary" size="small" @click="submit()">确定</el-button>
            </span>
        </el-dialog>

        <div class="el-card-title">
            <span>数据筛选</span>
        </div>
        <div class="filter-row">
            <div class="filter-item" v-if="!this.$store.getters.getUserInfo.storeId">
                <span class="filter-title">所属门店： </span>
                <el-select clearable v-model="pageCfg.storeId" @change="getCourseOrderList" placeholder="请选择所属门店">
                    <el-option v-for="(item, i) in storeList" :key="i" :label="item.name" :value="item.value"></el-option>
                </el-select> 
            </div>
            <div class="filter-item">
                <span class="filter-title">订单状态： </span>
                <el-select clearable v-model="pageCfg.status" @change="getCourseOrderList" placeholder="请选择订单状态">
                    <el-option v-for="(item, i) in statusList" :key="i" :label="item.name" :value="item.value"></el-option>
                </el-select> 
            </div>
        </div>
        <div class="el-card-title">
            <span>订单列表</span>
            <div :style="{ display: 'flex' }">
                <el-input
                    type="text"
                    class="table-search"
                    clearable
                    v-model="pageCfg.searchingContent"
                    prefix-icon="el-icon-search"
                    placeholder="请输入用户昵称或联系方式"
                    @input="handleInput"
                ></el-input>
                <el-tooltip effect="dark" content="订单导出" placement="top">
                    <el-button type="text" @click="dialog.visible = true">
                        <i class="mdi mdi-24px mdi-export"></i>
                    </el-button>
                </el-tooltip>
            </div>
        </div>
        <custom-table :table="tableData" :options="{
            maxHeight: 640
        }">
            <!-- <template slot="operation" slot-scope="item">
                <el-button type="text" :disabled="item.data.row.status != 1" size="small" @click="rejectOrder(item.data.row)">退单</el-button>
            </template> -->
        </custom-table>
        <el-pagination
            :current-page="pageCfg.currentPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="pageCfg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.pageTotal"
            @current-change="handlePageChange"
            @size-change="handleSizeChange">
        </el-pagination>
    </div>
</template>

<script>
import { OrderManagementApi } from '../http/orderManagement/orderManagement'; 
import { CommonApi } from '../http/common';
import CustomTable from '../components/customTable.vue';
export default {
    name: "course-order-management",
    components: {
        CustomTable
    },
    data(){
        return {
            pageCfg: {
                currentPage: 1,
                pageSize: 15,
                storeId: "",
                searchingContent: "",
                status: 1
            },
            tableData: {
                data: [],
                columns: [],
                tableLoading: false,
                pageTotal: 0
            },
            dialog: {
                visible: false,
                title: "",
                content: {
                    storeId: "",
                    begin: "",
                    end: ""
                }
            },
            storeList: [],
            statusList: [
                {
                    name: "成功支付（订单未失效）",
                    value: 1
                },
                {
                    name: "取消支付",
                    value: 2
                },
                {
                    name: "成功支付（订单已失效）",
                    value: 3
                },
                {
                    name: "成功支付（未成课）",
                    value: 4
                }
            ],
            token: "",
            timer: null
        }
    },
    mounted(){
        this.token = localStorage.getItem('authToken');
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.dialog.content.storeId = userInfo.storeId ? userInfo.storeId: "";
        this.pageCfg.storeId = userInfo.storeId ? userInfo.storeId: "";
        this.getCourseOrderList();
        this.getStoreList();
        
        // if(!this.pageCfg.storeId){
        // } else{
        // }
    },
    destroyed(){
        clearTimeout(this.timer);
    },
    methods: {
        getStoreList(){
            CommonApi.getStoreSelectorList().then(res => {
                this.storeList = res;
            })
        },
        getCourseOrderList(){
            this.tableData.tableLoading = true;
            OrderManagementApi.getCourseOrderList(this.pageCfg).then(res => {
                res.data.forEach(item => {
                    item.nickName = decodeURI(item.nickName);
                    // item.price = "¥" + (parseInt(item.price) / 100).toFixed(2);
                });
                Object.assign(this.tableData, res);
                this.tableData.tableLoading = false;
            })
        },
        handlePageChange(page){
            this.pageCfg.currentPage = page;
            this.getCourseOrderList();
        },
        handleSizeChange(size){
            this.pageCfg.pageSize = size;
            this.getCourseOrderList();
        },
        filterChange(){
            this.pageCfg.currentPage = 1;
            this.getCourseOrderList();
        },
        handleCancel(){
            this.dialog.visible = false;
            for(let key in this.dialog.content){
                this.dialog.content[key] = "";
            }
        },
        //输入搜索
        handleInput(){
            clearTimeout(this.timer);
            this.timer = null;
            this.pageCfg.currentPage = 1;
            this.timer = setTimeout(()=>{
                this.getCourseOrderList();
            }, 500)
        },
        submit(){
            OrderManagementApi.exportCourseOrder(this.dialog.content).then(res => {
                if(res){
                    var url = window.URL.createObjectURL(new Blob([res], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8'
                    }));
                    let a = document.createElement('a');
                    a.style.display = "none";
                    a.href = url;
                    a.click();
                    url = window.URL.revokeObjectURL(url);
                    document.body.removeChild(a)
                    this.$notify.success({title: "导出成功"});
                    this.handleCancel();
                } else{
                    this.$notify.warning({ title: res.data.message });
                }
            })
        }
    }
}
</script>

<style>

</style>